import { OfferType, ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';

export const OfferPageLoad = createAction('[GA View Offers] Page Load');

export const OfferShowMoreClick = createAction(
  '[GA View Offers] Show More Click',
  props<{ payload: OfferType }>()
);

export const OfferComparisonClick = createAction(
  '[GA View Offers] Card Comparison Click',
  props<{ payload: ReplacementOffer }>()
);

export const OfferCompareModelsClick = createAction(
  '[GA View Offers] Compare Models Click'
);

export const OfferCompareNowClick = createAction(
  '[GA View Offers] Compare Now Click'
);

export const OfferSpecDifferencesClick = createAction(
  '[GA View Offers] Compare show differences'
);

export type OfferActions =
  | typeof OfferPageLoad
  | typeof OfferShowMoreClick
  | typeof OfferComparisonClick
  | typeof OfferCompareModelsClick
  | typeof OfferCompareNowClick
  | typeof OfferSpecDifferencesClick;
